import { useState, useEffect } from 'react';

/**
 * Custom hook to manage search history using localStorage
 * @param {number} maxItems - Maximum number of items to store in history
 * @returns {Object} - Methods and data for managing search history
 */
const useSearchHistory = (maxItems = 6) => {
  const [searchHistory, setSearchHistory] = useState([]);

  // Load history from localStorage on mount
  useEffect(() => {
    const storedHistory = localStorage.getItem('searchHistory');
    if (storedHistory) {
      try {
        setSearchHistory(JSON.parse(storedHistory));
      } catch (error) {
        console.error('Failed to parse search history', error);
        setSearchHistory([]);
      }
    }
  }, []);

  // Save search term to history
  const addToHistory = (searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') return;
    
    setSearchHistory((prevHistory) => {
      // Remove duplicate if exists
      const filteredHistory = prevHistory.filter(
        (item) => item.toLowerCase() !== searchTerm.toLowerCase()
      );
      
      // Add new term at the beginning
      const newHistory = [searchTerm, ...filteredHistory].slice(0, maxItems);
      
      // Save to localStorage
      localStorage.setItem('searchHistory', JSON.stringify(newHistory));
      
      return newHistory;
    });
  };

  // Clear search history
  const clearHistory = () => {
    localStorage.removeItem('searchHistory');
    setSearchHistory([]);
  };

  return {
    searchHistory,
    addToHistory,
    clearHistory
  };
};

export default useSearchHistory; 